import BaseAPI from './base'

class CourseProgressAPI extends BaseAPI {}

export default new CourseProgressAPI('v1/course-progress', 'CourseProgress')
